<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part">
<header>
<h1 class="topictitle1" id="pa5"><a href="#/nav#npa5"><span class="section_number">Part I</span><br/><span class="title">Memphis Wonderland</span><br/></a></h1>
</header>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part_I.vue?7b90c2f6